module.exports = __webpack_public_path__ + "img/dashboard.ca0c9feb.png";